<template>
  <div>
    <h4 v-if="limitSecond > 0">
      {{ "time_ower" | setText("Осталось секунд:") }} {{ limitSecond }}
    </h4>

    <div v-if="!resendData">
      <div class="mb-2">
        <fg-input
          :type="`text`"
          :label="`Код из смс TBC_FIN`"
          :labelKey="`sms_code_tbc_fin`"
          v-model="data.code"
        ></fg-input>
      </div>

      <div class="mb-4">
        <video
          ref="videoElement"
          style="width: 100%; border-radius: 20px"
        ></video>
        <canvas style="width: 0; height: 0" ref="canvasElement"></canvas>
        <!-- <div>
          <button @click="capturePhoto" class="btn btn-info mt-3">
            {{ "photo" | setText("Сфотографировать") }}
          </button>
        </div> -->
      </div>

      <button @click="capturePhoto" class="btn btn-info mt-3 mw">
        {{ "next" | setText("Далее") }}
      </button>
    </div>
    <div v-else>
      <div class="install-control">
        <small class="text-right">
          {{
            "resend_text_photo"
              | setText(
                "Нажмайте далее с интервалом 30 секунд, MyID должент дать ответ"
              )
          }}</small
        >
        <button @click="send" class="btn btn-success">
          {{ "next_step" | setText("Далее") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "../../../plugins/functions";

export default {
  watch: {
    limitSecond(val) {
      if (val < 1) {
        this.$emit("setStep", "pre-scoring");
      }
    },
  },
  components: {
    informator: () => import("./Informator"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  async created() {
    setInterval(() => {
      this.limitSecond--;
    }, 1000);
  },
  name: "filter",

  mounted() {
    this.data["otp_id"] = this.value["otp_id"];
    this.data["pre_scoring_user_id"] = this.value["pre_scoring_user_id"];
    this.videoElement = this.$refs.videoElement;
    this.canvasElement = this.$refs.canvasElement;
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        this.videoStream = stream;
        this.videoElement.srcObject = stream;
        this.videoElement.play();
      })
      .catch((error) => {
        console.error("Error accessing user media:", error);
      });
  },

  methods: {
    async capturePhoto() {
      const context = this.canvasElement.getContext("2d");
      this.canvasElement.width = this.videoElement.videoWidth;
      this.canvasElement.height = this.videoElement.videoHeight;
      context.drawImage(this.videoElement, 0, 0);
      const base64Image = await this.canvasElement
        .toDataURL()
        .split(";base64,")[1];
      const binaryString = await atob(base64Image);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = await new Blob([bytes], { type: "image/jpeg" });
      const file = await new File([blob], "photo", { type: "image/jpeg" });
      this.data["photo"] = await file;

      this.send();
    },
    send() {
      this.$loading(true);
      let contentType = "multipart/form-data";
      let data = toFormData(this.data);
      let link = `send-data/${this.value["pre_scoring_user_id"]}?otp_id=${this.value["otp_id"]}&otp_value=${this.data.code}`;

      if (this.resendData == true) {
        contentType = "application/json";
        link = `resend-data`;
        data = {
          job_id: this.job_id,
          log_id: this.log_id,
        };
      }

      this.$http({
        url: `${this.partner["endpoint_url"]}${link}`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,

          "Content-Type": contentType,
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          if (response.data) {
            if (response.data.code == 202) {
              this.resendData = true;
              this.log_id = response.data.log_id;
              this.job_id = response.data.job_id;
            } else if (response.data.code == 1) {
              this.$emit("setStep", "confirm-pre-scoring");
              this.$emit("input", {
                ...this.value,
                ...response.data,
              });
            } else {
              this.$notify({
                title: `!!!`,
                message: response.data.message,
                icon: "ti-info",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            }
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async selectFile(event) {
      this.data["photo"] = await event.target.files[0];
    },
  },
  data() {
    return {
      limitSecond: 60,
      resendData: false,
      job_id: null,
      log_id: null,
      data: {
        photo: null,
        code: null,
      },
    };
  },
  beforeDestroy() {},
};
</script>

